module.exports = __webpack_public_path__ + "static/clearview-logo-72f3ebe557bd636a0e3ffc9999a4193a.png";